<div class="template">
  <div class="video-player">
    <video autoplay="autoplay" muted="muted" loop>
      <source src="{{ template.trailerUrl }}" type="video/mp4" />

      Your browser does not support the video tag.
    </video>

    <div class="buttons">
      <button (click)="chooseTemplateClicked(template)">Choose</button>
      <!-- <button>Preview</button>-->
    </div>
    <div class="item-overlay"></div>
  </div>

  <div class="description-panel">
    <div class="video-title">{{ template.title }}</div>
    <div class="soundbar">
      <soundbar></soundbar>
    </div>
  </div>
</div>
